// extracted by mini-css-extract-plugin
export default {"button__centered":"ButtonCentered_button__centered__CLfEz"};